export default "__VITE_ASSET__BXY8upLW__"